import { TooltipProps } from "recharts";
import CostChartTooltip from "@/pages/summary/components/CostChartTooltip";

// Synthetic per-row total consumed by the shared CostChartTooltip's
// "Total Cost" badge — the prefix is reserved so it never collides with
// a real compute pool name in the row data.
export const COMPUTE_POOLS_TOTAL_KEY = "__compute_pools_chart_total__";

const FALLBACK_COLOR = "#8390A3";

const ComputePoolsTooltip = (props: TooltipProps<number, string>) => {
  const { active, payload } = props;

  if (!active || !payload || payload.length === 0) return null;

  // Derive the field list from the recharts payload so the tooltip lists
  // exactly the bar segments rendered for this row (respects the legends
  // picker), with the total badge on top. Single-series charts (pool detail)
  // don't inject the synthetic total — the badge is skipped there.
  const hasTotal = typeof payload[0].payload?.[COMPUTE_POOLS_TOTAL_KEY] === "number";
  const fields = [
    ...(hasTotal
      ? [
          {
            key: { current: COMPUTE_POOLS_TOTAL_KEY, estimate: "" },
            label: "Total Cost",
            isTotal: true,
            hideSticker: true,
          },
        ]
      : []),
    ...payload.map(item => ({
      key: { current: String(item.dataKey), estimate: "" },
      label: String(item.name),
    })),
  ];

  const colorFor = (key: string) =>
    payload.find(item => String(item.dataKey) === key)?.color ?? FALLBACK_COLOR;

  return (
    <CostChartTooltip
      {...props}
      timeRange="day"
      fields={fields}
      colorFor={colorFor}
      // Pool names are user data — render verbatim, no title-casing.
      formatFieldLabel={label => label}
    />
  );
};

export default ComputePoolsTooltip;
